import { updateObjectState } from "../../utils/updateObjectStates"

export const handleBookingOptionsSelect = (deliveryOption, setBookingOptionsState) => {
    setBookingOptionsState((prevState)=>{ return updateObjectState('scheduledDelivery', 
    deliveryOption === 'scheduledDelivery'  , prevState)})
}

export const handleWayPointAddition = (optmizedBookingState,setOptimizedBookingState, setSelectedInputAddress, setWaypointLength) => {
    let updatedState = {...optmizedBookingState}
    let a = [...updatedState.waypoints]
    a.push({
        postal: "",
        name: "",
        number : "",
        notes : "",
        floor : "",
        unit : "",
        latitude: 0,
        longitude: 0,
        address: ""
     })
    updatedState.waypoints = a
    setOptimizedBookingState(updatedState)
    setSelectedInputAddress(()=> a.length-1)
    setWaypointLength(a.length)
}